import { ApplicationEvent } from './application-event.model';
import { ApplicationCategorySelectedEventType, ApplicationEventType } from '../constants';

export class CategorySelectedApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.CategorySelected;

  constructor(
    private categoryEventType: ApplicationCategorySelectedEventType,
    private categoryName: string,
    private promotionCategory?: {
      leaf_category: string,
      root_category: string
    },
    private categoryLevel?: number
  ) {
  }

  getPayload(): any {
    return {
      type: this.categoryEventType,
      categoryName: this.categoryName,
      promotionCategory: this.promotionCategory,
      categoryLevel: this.categoryLevel
    };
  }
}
